import { useEffect } from 'react';
import {SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../constants";
import store from "../../../../store";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../actions/sqftMenuFunctions";
import {isCabinetsFabricator} from "../../../../misc/fabricatorHardcode";

const useOpenSQFTMenu = () => {
  useEffect(() => {
    const state = store.getState();
    const sqftFromFeature = state.sqftState.sqftFromFeature;
    setTimeout(() => {
      if (sqftFromFeature && sqftFromFeature.cartFeature) {
        if (["top_cabinet", "upper_cabinet_boxes"].includes(sqftFromFeature.cartFeature.partId)) {
          store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper));
          store.dispatch(setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper));
        } else if (["bottom_cabinet", "bottom_cabinet_boxes"].includes(sqftFromFeature.cartFeature.partId)) {
          store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower));
          store.dispatch(setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower));
        } else if (isCabinetsFabricator() && ["center_island_countertop"].includes(sqftFromFeature.cartFeature.partId)) {
          store.dispatch(setSQFTMenuOpened(SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland));
          store.dispatch(setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland));
        }
      }
    }, 100)

  }, []);
};

export default useOpenSQFTMenu;
